import moment from "moment/moment";
import NoRecordsFound from "../../../components/no-records-found";

const AdminWalletTab = ({ data, tab }) => {
  const getHeaders = () => {
    switch (tab) {
      case "inbound":
        return [
          "Date",
          "Amount",
          "Currency",
          "Channel",
          "Subject",
          "Teacher",
          "Student",
          "Status",
        ];
      case "outbound":
        return ["Date", "Amount", "Currency", "Channel", "Status"];
      case "merge":
        return [
          "Date",
          "Type",
          "Amount",
          "Currency",
          "Channel",
          "Transaction Status",
          "Teacher",
          "Subject",
          "Session Status",
        ];
      default:
        return [];
    }
  };

  const renderRow = (item) => {
    if (tab === "inbound") {
      return (
        <tr key={item.id}>
          <td className="text-nowrap">
            {moment(item?.createdAt).format("MMM Do YY")}
          </td>
          <td className="text-nowrap">{item?.amount}</td>
          <td className="text-nowrap">{item?.currency}</td>
          <td className="text-nowrap">{"Bank Alfalah"}</td>
          <td className="text-nowrap">
            {item?.offerSlot?.offer?.offerSubjects?.map((x, index) => (
              <span key={index} className="badge bg-primary rounded-pill">
                {x?.subjectName}
              </span>
            ))}
          </td>
          <td className="text-nowrap">{item?.offerSlot?.teacher?.fullName}</td>
          <td className="text-nowrap">{item?.offerSlot?.student?.fullName}</td>
          <td className="text-nowrap">
            <span
              className={`badge rounded-pill ${
                item?.offerSlot?.status === "completed"
                  ? "bg-success"
                  : "bg-danger"
              }`}
            >
              {item?.offerSlot?.status}
            </span>
          </td>
        </tr>
      );
    } else if (tab === "outbound") {
      return (
        <tr key={item.id}>
          <td className="text-nowrap">
            {moment(item?.createdAt).format("MMM Do YY")}
          </td>
          <td className="text-nowrap">{item?.amount}</td>
          <td className="text-nowrap">{item?.currency}</td>
          <td className="text-nowrap">{"Bank Alfalah"}</td>
          <td className="text-nowrap">
            <span
              className={`badge rounded-pill ${
                item?.amount ? "bg-success" : "bg-danger"
              }`}
            >
              {item?.amount ? "Success" : "Failed"}{" "}
            </span>
          </td>
        </tr>
      );
    } else if (tab === "merge") {
      return (
        <tr key={item.id}>
          <td className="text-nowrap">
            {moment(item?.createdAt).format("MMM Do YY")}
          </td>
          <td className="text-nowrap">
            <span
              className={`badge rounded-pill ${
                item?.offerSlotId ? "bg-success" : "bg-danger"
              }`}
            >
              {item?.offerSlotId ? "COMMISSION" : "WITHDRAW"}
            </span>
          </td>
          <td className="text-nowrap">{item?.amount}</td>
          <td className="text-nowrap">{item?.currency}</td>
          <td className="text-nowrap">{"Bank Alfalah"}</td>
          <td className="text-nowrap">
            {item?.transactionDetails?.TransactionStatus ? (
              <span
                className={`badge rounded-pill ${
                  item?.transactionDetails?.TransactionStatus === "Success"
                    ? "bg-success"
                    : "bg-danger"
                }`}
              >
                {item?.transactionDetails?.TransactionStatus}
              </span>
            ) : (
              "--"
            )}
          </td>
          <td className="text-nowrap">
            {item?.offerSlot?.teacher?.fullName || "--"}
          </td>
          <td className="text-nowrap">
            {item?.offerSlot?.offer?.offerSubjects?.map((x, index) => (
              <span key={index} className="badge bg-primary rounded-pill">
                {x?.subjectName}
              </span>
            ))}
          </td>
          <td className="text-nowrap">
            {item?.offerSlot?.status ? (
              <span
                className={`badge rounded-pill ${
                  item?.offerSlot?.status === "completed"
                    ? "bg-success"
                    : "bg-danger"
                }`}
              >
                {item?.offerSlot?.status || "N/A"}
              </span>
            ) : (
              "--"
            )}
          </td>
        </tr>
      );
    }
  };

  const headers = getHeaders();

  return (
    <table className="table mb-0">
      <thead className="thead-light">
        <tr>
          {headers.map((header, idx) => (
            <th
              key={idx}
              style={{
                fontSize: "15px",
                color: "#333333",
                fontWeight: "500",
                minWidth: idx === 1 ? "140px" : "auto",
              }}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.length > 0 ? (
          data?.map(renderRow)
        ) : (
          <tr>
            <td colSpan={headers.length} className="text-center py-3">
              <NoRecordsFound />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AdminWalletTab;
